import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import { WatchedTabTitles, DriveWatchedMessages, useFetchWatchedActivity, WatchedLogsEntity, WatchedLogEntity, DriveWatchedErrorMessages, WatchedSidePanelProps } from "src/common";
import { CollapseWrapper, Loading } from "src/components";
import { ChangeRow } from ".";
import _ from "lodash";

const WATCHED_DETAIL_LOG_LIMIT = 5;
function ItemChangesComponent(props: WatchedSidePanelProps) {
    const { current_account, entry } = props;
    const [is_loading, setLoading] = useState<boolean>(true);
    const [is_error, setError] = useState<boolean>(false);
    const { fetchWatchedActivity, resetWatchedActivity, watched_activity, error } = useFetchWatchedActivity(current_account, entry, WATCHED_DETAIL_LOG_LIMIT, false);

    useEffect(() => {
        fetchWatchedActivity();
    }, []);

    useEffect(() => {
        !!watched_activity && handleWatchNotificationsSuccess(watched_activity);
        !!error && handleError(); // console.log("error", error);
    }, [watched_activity, error]);

    // Description: Fetch Activity for node
    function handleFetch() {
        if (!is_loading) {
            setError(false);
            setLoading(true);
            fetchWatchedActivity();
        }
    }

    // Description: Update UI after loading new data
    function handleWatchNotificationsSuccess(_watched_activity: WatchedLogsEntity) {
        setLoading(false);
        resetWatchedActivity();
    };

    // Description: Update UI after loading new data
    function handleError() {
        setLoading(false);
        setError(true);
        resetWatchedActivity();
    };

    // Description: empty message when no changes
    function detailList(entries: WatchedLogEntity[]) {
        return <>
            {
                _.map(entries, (entry, i) => {
                    return <ChangeRow
                        key={`entry_${i}`}
                        entry={entry}
                    />;
                })
            }
        </>;
    }

    // Description: empty message when no changes
    function EmptyMessage() {
        return <Alert variant={is_error ? "danger" : "info"}>
            <p>{
                is_error ? DriveWatchedErrorMessages.error_item_changes :
                    DriveWatchedMessages.watched_activity_empty
            }</p>
        </Alert>;
    }

    return <CollapseWrapper
        title={WatchedTabTitles.events}
        default_open
        isLoading={is_loading}
        refresh={handleFetch}
        className="changes">
        <div className="changes-body">
            {
                !!watched_activity && watched_activity.entries.length > 0 ?
                    detailList(watched_activity.entries) :
                    is_loading ? <Loading className="in-place mt-5" /> :
                        <EmptyMessage />
            }
        </div>
    </CollapseWrapper>;
}

export default React.memo(ItemChangesComponent);
